import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import 'vfonts/IBMPlexMono.css';
import './styles.scss';
import naive from 'naive-ui';
import { Chart, PieController, ArcElement, LineController, CategoryScale, LinearScale, PointElement, LineElement, Legend, BarController, BarElement } from 'chart.js';
Chart.defaults.font = {
  size: 12,
  family: 'sans-serif'
};
Chart.register(PieController, LineController, CategoryScale, LinearScale, PointElement, ArcElement, LineElement, Legend, BarController, BarElement);
import { EthersService } from './services';
import { toast } from './utils/notification.util';

async function init() {
  try {
    await EthersService.connect();
  } catch (_) {
    toast.info('Connect with Metamask');
  }
  
  document.body.style.backgroundImage = 'none';
  const app = createApp(App);
  app.use(naive);
  app.use(router);
  app.mount('#app');
}
init();